import styled, { keyframes } from "styled-components";

import { flexCenter, rem } from "@styles/Utilities.styled";


const loadingAnimation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(200%);
  }
`;

export const StyledAppLoader = styled.div`
  position: fixed;
  inset: 0;
  ${flexCenter}
  background-color: var(--clr-gray-100);

  .loader-container {
    ${flexCenter}
    flex-direction: column;
    height: 100vh;
    background-color: #f9fafb; /* Light background */
    font-family: Arial, Helvetica, sans-serif;
    background-color: var(--clr-gray-100);
  }

  .loader-text {
    font-size: 1rem;
    color: var(--clr-gray-400);
    margin-bottom: 0.5rem;
  }

  .loader-bar {
    position: relative;
    width: ${rem(200)};
    height: ${rem(4)};
    background-color: #e5e7eb; /* Light gray bar background */
    border-radius: 2px;
    overflow: hidden;
  }

  .loader-progress {
    width: 50%; /* This width can animate dynamically */
    height: 100%;
    background-color: var(--mantine-color-primary-6);
    animation: ${loadingAnimation} 1.5s infinite linear;
    border-radius: 2px;
  }
`;
